import { useEffect } from 'preact/hooks'

export function generateSrcSet(url, widths) {
  return widths.map((width) => `${url}&width=${width} ${width}w`).join(', ')
}

const IMAGE_WIDTHS = [320, 480, 560, 640, 720, 960]

export function getLowQualityPlaceholder(imageUrl) {
  if (!imageUrl) return 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAYAAAAfFcSJAAAAAXNSR0IArs4c6QAAAA1JREFUCB1j+Pjx438ACX0D04PrXz0AAAAASUVORK5CYII='
  return `${imageUrl}&width=5`
}

export function ResultImage({ result, children }) {
  useEffect(() => {
    if (window.lazyLoadInstance) {
      window.lazyLoadInstance.update()
    }
  }, [result?.images, result?.image])

  return (
    <div className="relative size-full overflow-hidden border-0">
      {result?.images?.length > 2 ? (
        <>
          <img
            key={result.images[1].src}
            className="lazy absolute inset-0 object-cover size-full bg-[--section-bg-colour,theme(colors.brand.white)]"
            src={getLowQualityPlaceholder(result.images[1].src)}
            data-src={result.images[1].src}
            data-srcset={generateSrcSet(result.images[1].src, IMAGE_WIDTHS)}
            data-sizes="50vw"
            alt={result.images[1].alt || result.title || 'Product image 1'}
          />
          <img
            key={result.images[0].src}
            className="lazy absolute inset-0 object-cover size-full transition-all bg-[--section-bg-colour,theme(colors.brand.white)] group-hover/card:opacity-0"
            src={getLowQualityPlaceholder(result.images[0].src)}
            data-src={result.images[0].src}
            data-srcset={generateSrcSet(result.images[0].src, IMAGE_WIDTHS)}
            data-sizes="50vw"
            alt={result.images[0].alt || result.title || 'Product image 2'}
          />
        </>
      ) : result.image ? (
        <img
          key={result.image}
          className="lazy object-cover size-full bg-[--section-bg-colour,theme(colors.brand.white)]"
          src={getLowQualityPlaceholder(result.image)}
          data-src={result.image}
          data-srcset={generateSrcSet(result.image, IMAGE_WIDTHS)}
          data-sizes="50vw"
          alt={result.image.alt || result.title || 'Product image'}
        />
      ) : null}
      {children}
    </div>
  )
}
